import { apiCall, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import {
  documentsExpertListMock,
  documentsListMock,
  getCoursesMock,
} from './mock';
import { parseQueryParams } from '../../utils/queryParams';
import { coursePath, documentPath } from '../../utils/paths';

export default {
  courseListGet: (filters) => {
    if (shouldUseMock()) {
      return getCoursesMock(filters);
    }
    return apiCall(
      `${baseUrl}${coursePath}course/search${parseQueryParams(filters)}`,
      'GET'
    );
  },
  documentsListGet: (filters) => {
    if (shouldUseMock()) {
      return documentsListMock();
    }
    return apiCall(
      `${baseUrl}${documentPath}documents/search${parseQueryParams(filters)}`,
      'GET'
    );
  },
  documentsExpertListGet: (filters) => {
    if (shouldUseMock()) {
      return documentsExpertListMock();
    }
    return apiCall(
      `${baseUrl}${documentPath}documents_for_experts/search${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
};
